import { Action } from '@ngrx/store';
import {
  Treatment,
  TreatmentSchema,
  CopyTreatmentsRequest,
  SalesOrderPeriod,
  Template,
} from 'src/app/shared/models';

export enum TemplateActionTypes {
  GetEditingTemplate = '[Template] Get editing template',
  FetchTemplate = '[Template] Fetch template',
  SetEditingTemplate = '[Template] Set editing template',
  AddTreatment = '[Template] Open create treatment dialog',
  EditTreatment = '[Template] Open edit treatment dialog',
  SaveTreatment = '[Template] Save treatment',
  RemoveTreatment = '[Template] Remove treatment',
  AddTreatmentSchema = '[Template] Add treatment schema',
  EditTreatmentSchema = '[Template] Edit treatment schema',
  SaveTreatmentSchema = '[Template] Save treatment schema',
  RemoveTreatmentSchema = '[Template] Remove treatment schema',
  OpenCopyTreatmentsDialog = '[Template] Open copy treatments dialog',
  CopyTreatments = '[Template] Copy treatments',
}

export class GetEditingTemplate implements Action {
  readonly type = TemplateActionTypes.GetEditingTemplate;
  constructor(public readonly id: number) {}
}

export class FetchTemplate implements Action {
  readonly type = TemplateActionTypes.FetchTemplate;
  constructor(public readonly id: number) {}
}

export class SetEditingTemplate implements Action {
  readonly type = TemplateActionTypes.SetEditingTemplate;
  constructor(public readonly template: Template) {}
}

export class AddTreatment implements Action {
  readonly type = TemplateActionTypes.AddTreatment;
}

export class EditTreatment implements Action {
  readonly type = TemplateActionTypes.EditTreatment;
  constructor(
    public readonly treatment: Treatment,
    public readonly index = -1,
  ) {}
}

export class SaveTreatment implements Action {
  readonly type = TemplateActionTypes.SaveTreatment;
  constructor(
    public readonly treatment: Treatment,
    public readonly index: number,
    public readonly salesOrderPeriods: SalesOrderPeriod[],
  ) {}
}

export class RemoveTreatment implements Action {
  readonly type = TemplateActionTypes.RemoveTreatment;
  constructor(public readonly treatment: Treatment) {}
}

export class AddTreatmentSchema implements Action {
  readonly type = TemplateActionTypes.AddTreatmentSchema;
}

export class EditTreatmentSchema implements Action {
  readonly type = TemplateActionTypes.EditTreatmentSchema;
  constructor(public readonly treatmentSchema: TreatmentSchema) {}
}

export class SaveTreatmentSchema implements Action {
  readonly type = TemplateActionTypes.SaveTreatmentSchema;
  constructor(public readonly treatmentSchema: TreatmentSchema) {}
}

export class RemoveTreatmentSchema implements Action {
  readonly type = TemplateActionTypes.RemoveTreatmentSchema;
  constructor(public readonly treatmentSchema: TreatmentSchema) {}
}

export class OpenCopyTreatmentsDialog implements Action {
  readonly type = TemplateActionTypes.OpenCopyTreatmentsDialog;
}

export class CopyTreatments implements Action {
  readonly type = TemplateActionTypes.CopyTreatments;
  constructor(public readonly request: CopyTreatmentsRequest) {}
}

export type TemplateActions =
  | GetEditingTemplate
  | FetchTemplate
  | SetEditingTemplate
  | AddTreatment
  | EditTreatment
  | SaveTreatment
  | RemoveTreatment
  | AddTreatmentSchema
  | EditTreatmentSchema
  | SaveTreatmentSchema
  | RemoveTreatmentSchema
  | OpenCopyTreatmentsDialog
  | CopyTreatments;
